import Vue from 'vue'
import Vuex from 'vuex'
import publicOptions from './public'
Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        publicOptions
    }
})